var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-attribute-value-inner center-render"},[(_vm.attribute.baseValue == 1)?_c('span',[_c('i',{staticClass:"boolean-true fas fa-check-circle"})]):_c('span',[_vm._v(" - ")])])}
var staticRenderFns = []

export { render, staticRenderFns }